module.exports = __webpack_public_path__ + "img/faixa1.4fb33865.png";